import { MarketingCalendarController } from './marketing-calendar.controller'

function marketingCalendar () {
  return {
    restrict: 'E',
    scope: {
      date: '<',
      viewMode: '<',
      deliveryView: '<',
      locale: '<',
      tasks: '<',
      onSeeMore: '<',
      campaigns: '<',
      originModule: '<'
    },
    templateUrl: '/workflow/directives/marketing-calendar/marketing-calendar.html?$$REVISION$$',
    controller: MarketingCalendarController
  }
}

export { marketingCalendar }
